import styled from 'styled-components';

const VideoIframe = styled.div`
  width: 100%;
  height: 100%;
  min-height: 380px;
`;

export { VideoIframe };
